// Shared URL safety helper.
//
// Many surfaces render URLs that originate from scraped or user-submitted
// data (event_url, exchange url, osm_url, meetup_url, business website). React
// does NOT block dangerous schemes in `href`, so a stored value like
// `javascript:...` or `data:...` executes on click. Route every untrusted URL
// through safeHref() before using it as an href / window.open target.

const SAFE_SCHEME = /^https?:\/\//i;

/**
 * Return the URL only if it is a safe http(s) absolute URL.
 * Bare domains (no scheme) are upgraded to https://. Anything else → null.
 *
 * @param {string} url
 * @returns {string|null} a safe URL, or null if it can't be made safe
 */
export function safeHref(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (SAFE_SCHEME.test(trimmed)) return trimmed;
  // Reject any other explicit scheme (javascript:, data:, mailto:, tel:, etc.)
  // — callers that want mailto/tel build those hrefs explicitly.
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return null;
  // Scheme-less (e.g. "example.com/x") → assume https.
  return `https://${trimmed}`;
}

export default safeHref;
